import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { inject } from 'mobx-react';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import ListItem from './ListItem';

@inject((stores) => ({
  isMobile: stores.UiStore.isMobile
}))
class ListItemLink extends Component {
  static propTypes = {
    to: PropTypes.string,
    isMobile: PropTypes.bool,
    location: PropTypes.object,
    onClick: PropTypes.func
  };

  parseTo(to) {
    const parser = document.createElement('a');

    parser.href = to;
    return parser;
  }

  isInternal(to) {
    return to.indexOf('://') === -1;
  }

  onClickHandler = () => {
    const { isMobile, onClick } = this.props;

    if (isMobile) {
      UiService.toggleSidebar(false);
    }

    onClick && onClick();
  };

  render() {
    const { to, location, ...props } = this.props;
    const isInternal = this.isInternal(to);

    if (!isInternal) {
      return (
        <a href={to}>
          <ListItem {...props} />
        </a>
      );
    }

    return (
      <NavLink exact to={to} onClick={this.onClickHandler} location={location}>
        <ListItem {...props} />
      </NavLink>
    );
  }
}

export default ListItemLink;
